<template>
  <div class="c--input_dropdown dropdown-wrapper position-relative">
    <div class="dropdown-wrapper-selected">
      <label :for="elementId">{{ label }}</label>
      <select
        :name="`${elementId}Name`"
        :id="elementId"
        :ref="`${elementId}Ref`"
        v-model="selectedModel"
        :class="`dir-${direction}`"
        @change.prevent="onChange"
      >
        <option v-for="(option, index) in options" :key="`${elementId}-option-${index}`" :value="option.value">
          {{ option.text }}
        </option>
      </select>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      id: {
        type: String,
        required: true,
      },

      label: {
        type: String,
        required: true,
      },

      options: {
        type: Array,
        required: true,
      },

      selected: {
        type: Object,
        required: false,
        default: {
          value: null,
          text: '',
        },
      },

      direction: {
        type: String,
        required: false,
        default: 'ltr', // ltr, rtl, auto
      },
    },

    data() {
      const selectedModel = this.selected.value

      return {
        selectedModel,
      }
    },

    computed: {
      elementId() {
        return `${this.id}Dropdown`
      },

      selectedValue() {
        return this.options.find((v) => v.value === this.selectedModel)
      },
    },

    watch: {
      selected(val) {
        if (val && val.value) {
          this.selectedModel = val.value
        }
      },
    },

    methods: {
      onChange() {
        this.$emit('onChange', this.selectedModel)
      },
    },
  }
</script>

<style lang="scss" scoped>
  .dropdown {
    &-wrapper {
      background-color: #f2f2f2;
      border: 1px solid #dddddd;
      border-radius: 7px;

      &-selected {
        display: flex;
        flex-direction: column;
        gap: 6px;

        label {
          outline: none;
          box-shadow: none;
          margin: 0;
          font-weight: 500;
          font-size: 11px;
          line-height: 1;
          color: #8a8a8a;
          position: absolute;
          left: 20px;
          top: 9px;
          z-index: 1;
        }

        select {
          font-weight: 400;
          font-size: 15px;
          line-height: 19px;
          color: #4a4a4a;
          margin: 0;
          appearance: none;
          border: none;
          outline: none;
          padding: 25px 32px 6px 20px;
          width: 100%;
          z-index: 2;
          box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);

          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;

          &.dir-rtl {
            background: url("data:image/svg+xml,%3Csvg width='12' height='7' viewBox='0 0 12 7' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M0 0.929791C0 1.18216 0.0865707 1.40133 0.266371 1.574L5.26082 6.66793C5.48058 6.90038 5.72031 7 6 7C6.28635 7 6.51942 6.90038 6.73918 6.66793L11.7336 1.574C11.9134 1.40133 12 1.1888 12 0.929791C12 0.418406 11.5871 0 11.0744 0C10.8213 0 10.5882 0.106262 10.4018 0.29222L6.00666 4.80835L1.59822 0.29222C1.41842 0.106262 1.18535 0 0.925638 0C0.412874 0 0 0.418406 0 0.929791Z' fill='%234A4A4A'/%3E%3C/svg%3E")
              left 20px center/12px 7px no-repeat;
            text-align: right;
          }

          &.dir-ltr,
          &.dir-auto {
            background: url("data:image/svg+xml,%3Csvg width='12' height='7' viewBox='0 0 12 7' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M0 0.929791C0 1.18216 0.0865707 1.40133 0.266371 1.574L5.26082 6.66793C5.48058 6.90038 5.72031 7 6 7C6.28635 7 6.51942 6.90038 6.73918 6.66793L11.7336 1.574C11.9134 1.40133 12 1.1888 12 0.929791C12 0.418406 11.5871 0 11.0744 0C10.8213 0 10.5882 0.106262 10.4018 0.29222L6.00666 4.80835L1.59822 0.29222C1.41842 0.106262 1.18535 0 0.925638 0C0.412874 0 0 0.418406 0 0.929791Z' fill='%234A4A4A'/%3E%3C/svg%3E")
              right 20px center/12px 7px no-repeat;
            text-align: left;
          }
        }
      }
    }
  }
</style>
